import Students from '@/views/Students'
import StudentDetails from '@/views/StudentDetails'

export default [
  {
    path: '/admin/organization/:organizationId/students',
    name: 'students',
    component: Students,
    props: true,
    meta: {
      menuItemIndex: '5',
      title:'Students'
    }
  },
  {
    path: '/organization/:organizationId/students/new',
    name: 'students-new',
    component: Students,
    props: (route) => {
      return {
        organizationId: route.params.organizationId,
        new: 'email-invite'
      }
    },
    meta: {
      menuItemIndex: '5',
      title:'Create Student'
    }
  },
  {
    path: '/organization/:organizationId/students/import',
    name: 'import-users',
    component: Students,
    props: (route) => {
      return {
        organizationId: route.params.organizationId,
        new: 'import-users'
      }
    },
    meta: {
      menuItemIndex: '5',
      title:'Import Users'
    }
  },
  {
    path: '/organization/:organizationId/elsa-users/import',
    name: 'import-elsa-users',
    component: Students,
    props: (route) => {
      return {
        organizationId: route.params.organizationId,
        new: 'import-elsa-users'
      }
    },
    meta: {
      menuItemIndex: '5',
      title:'Import Elsa Users'
    }
  },
  {
    path: '/organization/:organizationId/students/:studentId([A-Za-z0-9\\/+]+=|[0-9A-Fa-f\\-]{36})',
    name: 'student-details',
    component: StudentDetails,
    props: true,
    meta: {
      menuItemIndex: '5',
      title:'Student Details'
    }
  }
]
